<mat-toolbar class="app-toolbar">
  <span class="app-brand">{{ title }}</span>
  <span class="toolbar-spacer"></span>
  <app-theme-switcher></app-theme-switcher>
</mat-toolbar>

<div class="main-container">
  <app-conclave-settings></app-conclave-settings>

  <h2>Setup quick reference</h2>
  <table mat-table [dataSource]="setupReference" class="setup-table">
    <ng-container matColumnDef="players">
      <th mat-header-cell *matHeaderCellDef>Players</th>
      <td mat-cell *matCellDef="let row">{{ row.players }}</td>
    </ng-container>
    <ng-container matColumnDef="vps">
      <th mat-header-cell *matHeaderCellDef>VPs</th>
      <td mat-cell *matCellDef="let row">{{ row.vps }}</td>
    </ng-container>
    <ng-container matColumnDef="advancements">
      <th mat-header-cell *matHeaderCellDef>L1 Advancements</th>
      <td mat-cell *matCellDef="let row">{{ row.advancements }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="setupColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: setupColumns"></tr>
  </table>
</div>

<!-- If you don't need this ribbon, you can also uninstall the github-fork-ribbon-css npm package -->
<!-- The color for this ribbon is overridden in styles.scss -->
<a class="github-fork-ribbon right-top" href="https://github.com/kbarnes3/MysticVale" data-ribbon="Fork me on GitHub" title="Fork me on GitHub">Fork me on GitHub</a>
<footer class="footer" role="contentinfo">
  <div class="footer-inner">
    <p>&copy; 2018-2026 Kevin Barnes</p>
    <p>Built from version {{ gitVersion }}</p>
  </div>
</footer>
